export default [{
  path: '/validacao-atributos-mcpse',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Validacao de Atributos MCPSE Historico',
      path: 'historico',
      component: () => import('@/views/validacaoAtributosMcpse/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Validação de Atributos MCPSE' }
        ]
      }
    },
    {
      name: 'Validacao de Atributos MCPSE Adicionar',
      path: 'edit',
      component: () => import('@/views/validacaoAtributosMcpse/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Validação de Atributos MCPSE', path: '/validacao-atributos-mcpse/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]